import React from "react";
import { Typography, Grid } from "@material-ui/core";

export default function StepCircle({
    step,
    active,
    current,
    activeStatuses = [],
    currentStatuses = [],
}) {
    const className = ["step-icon"];
    const containerClassName = ["step-icon-container"];

    if (activeStatuses.includes(active)) {
        className.push("step-icon-active");
        containerClassName.push("step-icon-container-active");
    }

    if (currentStatuses.includes(current)) {
        className.push("step-icon-current");
        containerClassName.push("step-icon-container-current");
    }

    return (
        <Grid className={containerClassName.join(" ")}>
            <Typography
                component="p"
                className={className.join(" ")}
                style={{
                    fontSize: 24,
                    lineHeight: 1.17,
                    fontWeight: 700,
                    color: "#fff",
                }}
            >
                {step}
            </Typography>
        </Grid>
    );
}



// WEBPACK FOOTER //
// ./src/Order/StepCircle.jsx